module.exports = __webpack_public_path__ + "static/media/20170506-_DSC004601.ddb593c2.jpg";